import { dateConvertTimezone } from "src/app/platform/utils/functions";

export class PaymentsData {
    id: number;
    recipt: string;
    reciptFile: string;
    state: string;
    date: string;
    datePayment: string;
    amount: number;
    amountPending: number;
    methodPayment: string;

    constructor() {
        this.id = 0;
        this.recipt = '';
        this.reciptFile = '';
        this.state = '';
        this.date = '';
        this.datePayment = '';
        this.amount = 0;
        this.amountPending = 0;
    }

    configData(parameters: any): PaymentsData {
        this.id = parameters.id;
        this.recipt = parameters.comprobante;
        this.reciptFile = 'https://www.invoicesimple.com/wp-content/uploads/2018/06/Receipt-Template.xlsx';
        this.state = parameters.estado;
        this.date = dateConvertTimezone(new Date(parameters.fechaEmision), 'Etc/Greenwich');
        this.datePayment = dateConvertTimezone(new Date(parameters.fechaPago), 'Etc/Greenwich');
        this.amount = parameters.total.toFixed(2);
        this.amountPending = parameters.saldo.toFixed(2);
        this.methodPayment = parameters.medioPago;

        return this;
    }
}

export class BankData {
    id: number;
    name: string;

    constructor() {
        this.id = 0;
        this.name = '';
    }

    configData(parameters: any): BankData {
        this.id = parameters.id;
        this.name = parameters.nombre;

        return this;
    }
}

export class CardData {
    id: number;
    name: string;

    constructor() {
        this.id = 0;
        this.name = '';
    }

    configData(parameters: any): CardData {
        this.id = parameters.id;
        this.name = parameters.nombre;

        return this;
    }
}

export class DebitCardData {
    cardEntity: CardData;
    cardNumber: string;
    cardDateExpiration: string;
    holder: string;
    dni: string;
    bank: BankData;

    constructor() {
        this.cardEntity = new CardData();
        this.cardNumber = '';
        this.cardDateExpiration = '';
        this.holder = '';
        this.dni = '';
        this.bank = new BankData();
    }

    configData(parameters: any): DebitCardData {
        this.cardEntity = parameters.tarjeta;
        this.cardNumber = parameters.tarjetaNro;
        this.cardDateExpiration = parameters.tarjetaVto;
        this.holder = parameters.tarjetaTitular;
        this.dni = parameters.tarjetaDni;
        this.bank = new BankData().configData(parameters.banco);

        return this;
    }
}

export class DebitCBUData {
    number: string;
    holder: string;
    dni: string;
    bank: BankData;

    constructor() {
        this.number = '';
        this.holder = '';
        this.dni = '';
        this.bank = new BankData();
    }

    configData(parameters: any): DebitCBUData {
        this.number = parameters.debitoNro;
        this.holder = parameters.debitoTitular;
        this.dni = parameters.debitoDni;
        this.bank = new BankData().configData(parameters.banco);

        return this;
    }
}

export class PaymentGenerateData {
    tipo: string;
    id: number;
    importe: number;

    constructor(id?: number, type?: string, amount?: number) {
        this.id = (typeof id !== 'undefined' && id > 0) ? id : 0;
        this.tipo = (typeof type !== 'undefined' && type !== '') ? type : '';
        this.importe = (typeof amount !== 'undefined' && amount > 0) ? amount : 0;
    }
}
